import { a as __rest } from '../../tslib.es6.esm.js';
import { jsx } from 'react/jsx-runtime';
import React__default from 'react';
import { colorSwatchStyles } from './ColorSwatch.styles.esm.js';
import { cn } from '../../utils/cn.esm.js';

/**
 * ColorSwatch component displays a circular color swatch with a radial gradient.
 * It's used to represent vehicle colors or other color selections in a visual format.
 *
 * Color swatch is not focusable and is treated as decorative. It must have an accompanying text label.
 *
 * @param variant - The color variant to display
 * @param className - Additional CSS classes
 */
const ColorSwatch = React__default.forwardRef((_a, ref) => {
    var { variant, className } = _a, props = __rest(_a, ["variant", "className"]);
    return (jsx("span", Object.assign({ ref: ref, className: cn(colorSwatchStyles({ variant }), className), "aria-hidden": "true" }, props)));
});
ColorSwatch.displayName = "ColorSwatch";

export { ColorSwatch };
